import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {NavLink, useParams} from "react-router-dom";
import {AutoSizer, InfiniteLoader} from "react-virtualized";
import {StoreState} from "../store/StoreState";
import {Actions} from "../store/Actions";
import {ServerApi} from "../ServerApi";
import {List} from "react-virtualized";
import {IndexWord} from "../models/models";
import {Resizable} from "re-resizable";
import {Option} from "react-multi-select-component/dist/lib/interfaces";


export const IndexWordListComponent: React.FC<any> = () => {
	const dispatch = useDispatch();

	const {wordIdParam} = useParams();

	const user = useSelector((state: StoreState) => state.authInfo);

	const [allDictionaryGroups, setAllDictionaryGroups] = useState<Option[]>([]);
	const indexWords = useSelector((state: StoreState) => state.indexWords);
	const indexWordsCount = useSelector((state: StoreState) => state.indexWordsCount);
	const selectedSearchDictionaryGroups = useSelector((state: StoreState) => state.selectedSearchDictionaryGroups);
	const [selectedWordIndex, setSelectedWordIndex] = useState<number | undefined>(undefined);


	useEffect(() => {
		ServerApi
			.getDictionaryGroups()
			.then(dgs => {
				const allDictionaryGroups = dgs.map(dg => ({value: dg.id, label: dg.name} as Option));
				setAllDictionaryGroups(allDictionaryGroups);
			});
	}, []);


	useEffect(() => {
		// let foo = selectedSearchDictionaryGroups.map(o => o.value as number);
		//
		// if (allDictionaryGroups.length === selectedSearchDictionaryGroups.length) {
		// 	foo = [];
		// }

		ServerApi
			.getIndexWordsCount(selectedSearchDictionaryGroups.map(o => o.value as number))
			.then(data => dispatch(Actions.setIndexWordsCountAction(data)));
	}, [dispatch, indexWordsCount]);


	useEffect(() => {
		dispatch(Actions.deleteIndexWordAction(0));
	}, [selectedSearchDictionaryGroups]);


	useEffect(() => {
		if (Number(wordIdParam)) {
			// let foo = selectedSearchDictionaryGroups.map(o => o.value as number);
			//
			// if (allDictionaryGroups.length === selectedSearchDictionaryGroups.length) {
			// 	foo = [];
			// }

			ServerApi
				.getIndexWordIndex(Number(wordIdParam), selectedSearchDictionaryGroups.map(o => o.value as number))
				.then(data => setSelectedWordIndex(data - 3 < 0 ? data : data - 3))
				.then(() => setTimeout(() => {
					setSelectedWordIndex(undefined);
				}, 500));
		}
	}, [wordIdParam, indexWordsCount]);


	const getRowsFromServer = ({startIndex, stopIndex}: { startIndex: number, stopIndex: number }) => {
		// let foo = selectedSearchDictionaryGroups.map(o => o.value as number);
		//
		// if (allDictionaryGroups.length === selectedSearchDictionaryGroups.length) {
		// 	foo = [];
		// }

		return ServerApi
			.getIndexWords(startIndex, stopIndex, selectedSearchDictionaryGroups.map(o => o.value as number))
			.then(data => dispatch(Actions.setIndexWordsAction({startIndex, stopIndex, loadedIndexWords: data})));
	};


	const isRowLoaded = ({index}: { index: number }) => {
		return !!indexWords[index];
	};


	return (
		<Resizable
			style={{position: "sticky", float: "left", top: "0", background: "#eeeeee", borderRight: "1px gray solid", zIndex: 1}}
			defaultSize={{
				width: "180px",
				height: "100vh"
			}}
			enable={{top: false, right: true, bottom: false, left: false, topRight: false, bottomRight: false, bottomLeft: false, topLeft: false}}
			grid={[30, 30]}
			minWidth={180}
			maxWidth={500}
		>
			<div style={{width: "100%", height: "100%"}} onKeyDown={e => {
				if (e.key === "Delete") {
					if (user && user.role === "Admin") {
						if (window.confirm("정말로 선택된 용어들을 삭제하시겠습니까?")) {
							const wordIdsToDelete = (Object.values(indexWords) as unknown as Array<IndexWord>)
								.filter(iw => iw.deleteChecked)
								.map(iw => iw.id);

							ServerApi
								.deleteManyWords(wordIdsToDelete)
								.then((deletedCount) => {
									dispatch(Actions.deleteDeleteCheckedIndexWordsAction());
									alert(`${deletedCount}개의 용어가 삭제 되었습니다.`);
								});
						}
					}
				}
			}}>
				<AutoSizer>
					{({height, width}) => (
						<InfiniteLoader
							isRowLoaded={isRowLoaded}
							loadMoreRows={getRowsFromServer}
							rowCount={indexWordsCount}
							// minimumBatchSize={50}
						>
							{({onRowsRendered, registerChild}) => (
								<List
									className="index_word_list"
									ref={registerChild}
									onRowsRendered={onRowsRendered}
									width={width}
									height={height}
									rowHeight={30}
									scrollToIndex={selectedWordIndex}
									scrollToAlignment={"start"}
									rowCount={indexWordsCount}
									rowRenderer={(row) => {
										return (
											<div key={row.key}
											     style={{
												     ...row.style,
												     textOverflow: "ellipsis",
												     whiteSpace: "nowrap",
												     overflow: "hidden",
											     }}>

												{isRowLoaded({index: row.index})
													?
													<>
														{(user && user.role === "Admin") &&
                                                        <input type="checkbox" checked={indexWords[row.index]?.deleteChecked || false}
                                                               onChange={e => dispatch(Actions.checkDeleteIndexWordAction({indexWordIndex: row.index, deleteChecked: e.target.checked}))}/>
														}

														<NavLink to={`/${indexWords[row.index]?.id}`}
														         title={indexWords[row.index]?.term}
														         style={{
															         color: "black",
															         textDecoration: "none",
														         }}
														         activeStyle={{
															         color: "blue",
															         fontWeight: "bold"
														         }}
														>
															{indexWords[row.index]?.term}
														</NavLink>
													</>
													:
													<>로딩중...</>
												}

											</div>
										)
									}}
								/>
							)}
						</InfiniteLoader>
					)}
				</AutoSizer>
			</div>
		</Resizable>
	)
};